import { default as AppManager } from './app-manager';
import { default as FragmentManager } from './fragment-manager';
import * as utils from './utils';
import { default as ConfigManager } from './config-manager';
import { default as UserPreferenceManager } from './preference-manager';
import eventBus from './event-bus';
import ProxyManager from './proxies';
const eurekaMgrs = {
  ProxyManager,
  AppManager,
  FragmentManager,
  ConfigManager,
  UserPreferenceManager,
  utils,
  eventBus,
};
export default eurekaMgrs;
